export default __webpack_public_path__ + "static/media/ic_bank_account.a96d1fef.svg";